import { render } from "./DashboardProject.vue?vue&type=template&id=05c565b6&scoped=true"
import script from "./DashboardProject.vue?vue&type=script&lang=js"
export * from "./DashboardProject.vue?vue&type=script&lang=js"

import "./DashboardProject.vue?vue&type=style&index=0&id=05c565b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c565b6"]])

export default __exports__